// Baked into the JS bundle at build time; must equal backend APP_VERSION (a test pins them together).
export const UI_VERSION = "v1.25.2";
